// tour_360_Client/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import reportWebVitals from './reportWebVitals';

// Importa los estilos y configuraciones que necesitas
import './styles/index.css';
import './components/i18n.js';

// Importa el nuevo componente principal desde la carpeta `components`
import FullApp from './components/FullApp';

// Configuración global de Axios para incluir cookies en todas las peticiones
axios.defaults.withCredentials = true;

// Eliminamos el componente 'App' que tenías aquí
// const App = () => {
//     return (
//         <div className="App" >
//             <MagicAppear/>
//         </div>
//     );
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Renderiza el nuevo componente principal 'FullApp' */}
    <FullApp />
  </React.StrictMode>
);

reportWebVitals();